import { NavMarker } from 'react-rhumb';
import { Table, SortTH } from 'foundations-components/transitional/components/Table';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ApiError from '../../../../components/Errors/ApiError';
import { useIndividualCertificationOverview } from '../../myTeamQueries';
import ACTableSkeleton from 'academy-common-lib/components/loading/ACTableSkeleton';
import UserAvatarLink from '../common/UserAvatarLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useCertificationProfileInProgressTableStore } from '../../store/myTeamTableStateStore';
import { useParams } from 'react-router-dom';
import { parseCertificationStatusFilter } from '../../utils/filterUtils';
import EmptyTable from '../common/EmptyTable';
import MyTeamTablePagination from '../common/TablePagination';
import { useTableSorting } from '../../hooks/tableHooks';
import { getOffsetPosition, getPaginatedPosition } from '../../utils/paginationUtils';
import ProgressDisplay from '../common/ProgressDisplay';
import { useTheme } from 'foundations-theming/utils';
import { useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CertificationProfileInProgressTable = () => {
  const theme = useTheme();
  const {
    certificationId,
    certificationStatus: certificationStatusParam
  } = useParams();
  const certificationProfileInProgressTableStore = useCertificationProfileInProgressTableStore();
  const {
    state: {
      search,
      teams,
      users,
      sortBy,
      sortOrder,
      page,
      pageSize
    },
    actions: {
      resetTableState,
      setSortBy,
      setSortOrder,
      setPage,
      setPageSize
    }
  } = certificationProfileInProgressTableStore;
  const {
    isNotTablet
  } = useMediaQuery();
  const totalResultsRef = useRef(0);
  const {
    handleSortChange,
    getSortDirectionForColumn
  } = useTableSorting({
    sortBy,
    sortOrder,
    setSortBy,
    setSortOrder
  });
  const offsetPosition = getOffsetPosition(page, pageSize);
  const {
    data: teamMemberRecords,
    loading,
    error
  } = useIndividualCertificationOverview({
    certificationId: Number(certificationId),
    certificationStatus: parseCertificationStatusFilter(certificationStatusParam),
    teamIds: teams,
    userIds: users,
    nameFilter: search,
    pageLength: pageSize,
    pageSize,
    sortField: sortBy,
    sortOrder: sortOrder,
    offset: {
      offsetPosition
    }
  });
  if ((teamMemberRecords === null || teamMemberRecords === void 0 ? void 0 : teamMemberRecords.results.length) === 0) {
    return /*#__PURE__*/_jsx(EmptyTable, {
      navMarkerName: "CERTIFICATION_TABLE_EMPTY",
      onResetClick: resetTableState
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "CERTIFICATION_TABLE_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  if (!loading && teamMemberRecords) {
    totalResultsRef.current = teamMemberRecords.total;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading ? /*#__PURE__*/_jsx(ACTableSkeleton, {
      columns: 2,
      condensed: true,
      rows: pageSize
    }) : teamMemberRecords && /*#__PURE__*/_jsx(NavMarker, {
      name: "CERTIFICATION_TABLE_LOADED",
      children: /*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "certification-profile-table",
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            style: {
              width: '50%',
              borderInlineEnd: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
            }
          }), /*#__PURE__*/_jsx("col", {
            style: {
              width: '50%'
            }
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx(SortTH, {
              onClick: () => handleSortChange('USER_NAME'),
              sort: getSortDirectionForColumn('USER_NAME'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.tableColumns.name"
              })
            }), /*#__PURE__*/_jsx(SortTH, {
              onClick: () => handleSortChange('PROGRESS'),
              sort: getSortDirectionForColumn('PROGRESS'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.tableColumns.progress"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: teamMemberRecords.results.map(({
            userId,
            userEmail,
            userName,
            progress
          }, index) => {
            return /*#__PURE__*/_jsxs("tr", {
              "data-test-id": "certification-profile-in-progress-table-data-row",
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(UserAvatarLink, {
                  displayAvatar: isNotTablet,
                  position: getPaginatedPosition(offsetPosition, index),
                  userEmail: userEmail,
                  userId: userId,
                  userName: userName
                })
              }), /*#__PURE__*/_jsx("td", {
                "data-test-id": "table-progress",
                children: /*#__PURE__*/_jsx(ProgressDisplay, {
                  progress: progress
                })
              })]
            }, userId);
          })
        })]
      })
    }), /*#__PURE__*/_jsx(MyTeamTablePagination, {
      onPageChange: setPage,
      onPageSizeChange: setPageSize,
      page: page,
      pageSize: pageSize,
      totalResults: totalResultsRef.current
    })]
  });
};
export default CertificationProfileInProgressTable;